(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    if (window.__wdMenuHoverInitialized) return;
    window.__wdMenuHoverInitialized = true;

    const desktopQuery = window.matchMedia('(min-width: 990px)');
    const closeTimeouts = new Map();
    let activeMenu = null;

    const isPointerOverMenu = (menuItem, content, x, y) => {
      return [menuItem, content].filter(Boolean).some((node) => {
        const rect = node.getBoundingClientRect();
        return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
      });
    };

    const clearCloseTimeout = (menuItem) => {
      const timeout = closeTimeouts.get(menuItem);
      if (timeout) {
        clearTimeout(timeout);
        closeTimeouts.delete(menuItem);
      }
    };

    const getPanelType = (menuItem) => {
      if (menuItem.classList.contains('wd-mega-target--wallpaper')) return 'wallpaper';
      if (menuItem.classList.contains('wd-mega-target--help')) return 'help';
      if (menuItem.classList.contains('wd-mega-target--contact')) return 'contact';
      return null;
    };

    const getPanelWidth = (type) => {
      // Keep these in sync with the --wd-panel-* variables in wd-premium-menu.css.
      const isWidescreen = window.innerWidth >= 1440;
      const widths = isWidescreen
        ? { wallpaper: 1080, help: 620, contact: 340 }
        : { wallpaper: 960, help: 560, contact: 340 };
      const gutter = 48;
      return Math.min(widths[type] || 620, window.innerWidth - gutter);
    };

    const positionMegaPanel = (menuItem) => {
      const content = menuItem.querySelector('.mega-menu__content.wd-mega-content');
      const type = getPanelType(menuItem);
      if (!content || !type || !menuItem.hasAttribute('open')) return;

      const header = document.querySelector('.section-header .header') || document.querySelector('.header');
      const headerBottom = header ? header.getBoundingClientRect().bottom : 80;
      const detailsRect = menuItem.getBoundingClientRect();
      const panelWidth = getPanelWidth(type);

      content.style.setProperty('position', 'fixed', 'important');
      content.style.setProperty('top', `${headerBottom}px`, 'important');
      content.style.setProperty('width', `${panelWidth}px`, 'important');
      content.style.setProperty('right', 'auto', 'important');

      if (type === 'contact') {
        content.style.setProperty('padding-top', '0', 'important');
        content.style.setProperty('overflow', 'hidden', 'important');
        content.style.setProperty('border-radius', '18px', 'important');
        content.style.setProperty('background', '#fff', 'important');
        content.style.setProperty('box-shadow', '0 8px 22px rgba(20, 38, 58, 0.06)', 'important');
      } else {
        content.style.setProperty('padding-top', '0.6rem', 'important');
        content.style.removeProperty('overflow');
        content.style.removeProperty('border-radius');
        content.style.removeProperty('background');
        content.style.removeProperty('box-shadow');
      }

      if (type === 'wallpaper') {
        const viewportLeft = Math.max(20, (window.innerWidth - panelWidth) / 2);
        content.style.setProperty('left', `${viewportLeft}px`, 'important');
        content.style.setProperty('transform', 'none', 'important');
      } else {
        const centerX = detailsRect.left + detailsRect.width / 2;
        const halfPanel = panelWidth / 2;
        const clampedCenter = Math.max(
          20 + halfPanel,
          Math.min(centerX, window.innerWidth - 20 - halfPanel)
        );
        content.style.setProperty('left', `${clampedCenter}px`, 'important');
        content.style.setProperty('transform', 'translateX(-50%)', 'important');
      }

      // Height handling: on normal laptops the compact CSS keeps the panel short
      // enough to fit, so we keep it NON-scrolling (rounded corners intact).
      // Only when the panel is genuinely taller than the space below the header
      // (e.g. a very short window) do we cap it and enable internal scrolling.
      const verticalGap = 16;
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const available = viewportHeight - headerBottom - verticalGap;

      // Measure the natural height with no cap applied.
      content.style.setProperty('max-height', 'none', 'important');
      content.style.setProperty('overflow', 'hidden', 'important');
      const naturalHeight = content.scrollHeight;

      if (naturalHeight > available) {
        content.style.setProperty('max-height', `${Math.max(260, available)}px`, 'important');
        content.style.setProperty('overflow-y', 'auto', 'important');
        content.style.setProperty('overflow-x', 'hidden', 'important');
        content.style.setProperty('overscroll-behavior', 'contain', 'important');
      } else {
        content.style.removeProperty('max-height');
        content.style.removeProperty('overflow-y');
        content.style.removeProperty('overflow-x');
        content.style.removeProperty('overscroll-behavior');
        // Keep corners clipped without becoming a scroll container.
        content.style.setProperty('overflow', 'hidden', 'important');
      }
    };

    const resetMegaPanel = (menuItem) => {
      const content = menuItem?.querySelector('.mega-menu__content.wd-mega-content');
      if (!content) return;
      ['position', 'left', 'top', 'width', 'right', 'transform', 'padding-top', 'overflow', 'overflow-y', 'overflow-x', 'overscroll-behavior', 'max-height', 'background', 'border-radius', 'box-shadow'].forEach((prop) => {
        content.style.removeProperty(prop);
      });
    };

    const closeAllExcept = (root, menuItem) => {
      root.querySelectorAll('details.mega-menu.wd-mega-target[open]').forEach((openItem) => {
        if (openItem !== menuItem) {
          openItem.removeAttribute('open');
          resetMegaPanel(openItem);
        }
      });
    };

    const closeMenu = (menuItem) => {
      clearCloseTimeout(menuItem);
      menuItem.removeAttribute('open');
      resetMegaPanel(menuItem);
      if (activeMenu?.menuItem === menuItem) {
        activeMenu = null;
        document.removeEventListener('mousemove', onDocumentPointerMove);
      }
    };

    const openMenu = (root, menuItem, content) => {
      if (!desktopQuery.matches) return;
      clearCloseTimeout(menuItem);
      closeAllExcept(root, menuItem);
      menuItem.setAttribute('open', '');
      // Timestamp used to swallow the click that belongs to the same tap on
      // touch devices (tap fires simulated mouseenter/focus first, which opens
      // the menu; the trailing click would otherwise toggle it closed again).
      menuItem.dataset.wdOpenedAt = String(Date.now());
      if (getPanelType(menuItem)) {
        requestAnimationFrame(() => positionMegaPanel(menuItem));
      }
      activeMenu = { menuItem, content };
      document.addEventListener('mousemove', onDocumentPointerMove);
    };

    const onDocumentPointerMove = (event) => {
      if (!activeMenu) return;
      const { menuItem, content } = activeMenu;
      if (isPointerOverMenu(menuItem, content, event.clientX, event.clientY)) {
        clearCloseTimeout(menuItem);
        return;
      }
      clearCloseTimeout(menuItem);
      const timeout = setTimeout(() => {
        if (!isPointerOverMenu(menuItem, content, event.clientX, event.clientY)) {
          closeMenu(menuItem);
        }
      }, 120);
      closeTimeouts.set(menuItem, timeout);
    };

    const bindHoverEvents = (root = document) => {
      if (!desktopQuery.matches) return;

      root.querySelectorAll('.wd-menu-desktop header-menu').forEach((headerMenu) => {
        const menuItem = headerMenu.querySelector('details.mega-menu.wd-mega-target');
        if (!menuItem || headerMenu.dataset.wdHoverBound === 'true') return;

        const content = menuItem.querySelector('.mega-menu__content');
        const summary = menuItem.querySelector('summary');
        if (!content || !summary) return;

        const openHandler = () => {
          openMenu(root, menuItem, content);
        };
        const cancelClose = () => clearCloseTimeout(menuItem);
        const scheduleClose = (event) => {
          const related = event?.relatedTarget;
          if (related && (menuItem.contains(related) || content.contains(related))) return;
          clearCloseTimeout(menuItem);
          const timeout = setTimeout(() => closeMenu(menuItem), 150);
          closeTimeouts.set(menuItem, timeout);
        };

        menuItem.addEventListener('toggle', () => {
          if (menuItem.hasAttribute('open')) {
            requestAnimationFrame(() => positionMegaPanel(menuItem));
          } else {
            resetMegaPanel(menuItem);
          }
        });

        // Touch fix: a single tap fires mouseenter/focus (which open the menu)
        // followed by click on the summary, whose default action would toggle
        // the freshly opened <details> closed again — forcing a second tap.
        // If the click arrives right after we opened the menu, cancel the
        // default toggle so the first tap leaves the menu open. A later click
        // (> 600ms) still closes the menu as usual.
        summary.addEventListener('click', (event) => {
          if (!desktopQuery.matches) return;
          const openedAt = Number(menuItem.dataset.wdOpenedAt || 0);
          if (menuItem.hasAttribute('open') && Date.now() - openedAt < 600) {
            event.preventDefault();
          }
        });

        headerMenu.addEventListener('mouseenter', openHandler);
        headerMenu.addEventListener('mouseleave', scheduleClose);
        summary.addEventListener('mouseenter', openHandler);
        summary.addEventListener('focus', openHandler);
        content.addEventListener('mouseenter', cancelClose);
        content.addEventListener('mouseleave', scheduleClose);

        headerMenu.dataset.wdHoverBound = 'true';
      });
    };

    const init = () => bindHoverEvents(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('.wd-menu-desktop')) {
        bindHoverEvents(event.target);
      }
    });

    desktopQuery.addEventListener('change', () => {
      document.querySelectorAll('.wd-menu-desktop details.mega-menu.wd-mega-target[open]').forEach((menuItem) => {
        menuItem.removeAttribute('open');
        resetMegaPanel(menuItem);
      });
      activeMenu = null;
      document.removeEventListener('mousemove', onDocumentPointerMove);
    });

    let megaPanelScrollRaf = null;
    const scheduleMegaReposition = () => {
      if (megaPanelScrollRaf) return;
      megaPanelScrollRaf = requestAnimationFrame(() => {
        megaPanelScrollRaf = null;
        document.querySelectorAll('.wd-mega-target[open]').forEach((menuItem) => {
          positionMegaPanel(menuItem);
        });
      });
    };

    window.addEventListener('resize', scheduleMegaReposition, { passive: true });
    window.addEventListener('scroll', scheduleMegaReposition, { passive: true });
  })();

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
